import AuditEditState from "../types/AuditEditState";

export default function selectChecklistVersion(state: AuditEditState) {
    const checklistVersionId = state.audits[state.auditId ?? -1]?.checklistVersionId;
    return checklistVersionId ? state.checklistVersions[checklistVersionId] : undefined;
}